import { render, staticRenderFns } from "./EditPrice.vue?vue&type=template&id=3167fb45&scoped=true&"
import script from "./EditPrice.vue?vue&type=script&lang=js&"
export * from "./EditPrice.vue?vue&type=script&lang=js&"
import style0 from "./EditPrice.vue?vue&type=style&index=0&id=3167fb45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3167fb45",
  null
  
)

export default component.exports